module.exports = __webpack_public_path__ + "media/assets/images/category/MusicVideos@2x-d8a8b75b77243bc2a3974ffaa2b099d5.png";